var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1F845A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.001 16.666a6.667 6.667 0 100-13.333 6.667 6.667 0 000 13.333zm0 1.667a8.333 8.333 0 100-16.667 8.333 8.333 0 000 16.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.164 13.049a.25.25 0 00.353 0l5.028-5.028a.25.25 0 000-.353l-.825-.825a.25.25 0 00-.354 0l-3.849 3.849a.25.25 0 01-.353 0L7.19 8.718a.25.25 0 00-.354 0l-.825.825a.25.25 0 000 .353l3.153 3.153z"
  }))));
}
export default SvgSuc;